// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: true,
  baseAppUrl :"http://sharpnet.co.in/",
  baseApiUrl : "http://spraapi.sharpnet.co.in/",
  cookieDomain : ".sharpnet.co.in",
  //Added by rahul yadav on 6/9/2021 for cookie expiry time
  CooKieExpireTime:0.083 //in day i.e.=>(1*2)/24=0.083 day=2 hours
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
